class AssetManager {
  get(key) {
    return AppData.assets[key]
  }
}

export default new AssetManager
